import { TableCell, TableHead, TableRow } from "@mui/material";

export default function LogsTableHead({ headLabel }) {
  return (
    <TableHead sx={{ backgroundColor: "grey.200" }}>
      <TableRow>
        {headLabel.map((headCell) => {
          return (
            <TableCell
              key={headCell.id}
              align="center"
              sx={{
                textTransform: "uppercase",
                fontWeight: "bold",
                fontSize: "14px",
                width: headCell.id === "title" ? "20%" : "auto", 
                padding: "16px 16px", 
              }}
            >
              {headCell.label}
            </TableCell>
          );
        })}
      </TableRow>
    </TableHead>
  );
}
